import * as React from 'react';
import { cn } from '@noor/lib/cn';
import { FiltersProvider } from './filters-context';

export interface FiltersRootProps {
  /** Search-param keys this filter bar manages (drives Clear + active state). */
  managedKeys: string[];
  /** Pagination param to reset to 1 on any change. Defaults to `page`. */
  pageKey?: string;
  className?: string;
  children: React.ReactNode;
}

/**
 * Root of the `Filters` compound component. Provides URL-search-param access to
 * its children. Pages drop this in and compose `Filters.Search`, `.Select`,
 * etc. — no per-page navigate wiring.
 */
export function FiltersRoot({
  managedKeys,
  pageKey,
  className,
  children,
}: FiltersRootProps) {
  return (
    <FiltersProvider managedKeys={managedKeys} {...(pageKey ? { pageKey } : {})}>
      <div
        data-slot="filters"
        role="search"
        className={cn('flex flex-wrap items-center gap-2 pl-1', className)}
      >
        {children}
      </div>
    </FiltersProvider>
  );
}
